import { ItemRecapCard } from "./ItemRecapCard";

export default ItemRecapCard;
